import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {
    IAttributeConfData,
    IAttributeConfDataOption
} from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Client } from '@df/core/service/client';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductStatusDirective } from '../../product-status.directive';
import { PRODUCT_WISHLIST_ADD_EVENT_NAME, PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME } from '../../product.abstract';
import { ProductViewExternalComponent } from '../../view/external/product-view-external.component';
import { ProductViewLayoutComponent } from '../../view/layout/product-view-layout.component';
import { ProductConfigurableOptionsAbstract } from '../product-configurable-options.abstract';

@Component({
    selector: 'product-configurable-options-size',
    templateUrl: './product-configurable-options-size.component.html',
    styleUrl: './product-configurable-options-size.component.scss',
    standalone: true,
    imports: [CommonModule, GridModule, ProductStatusDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductConfigurableOptionsSizeComponent extends ProductConfigurableOptionsAbstract implements OnInit, OnDestroy {
    @Input()
    wishlist = false;

    @Input()
    override parentView!: ProductViewExternalComponent | ProductViewLayoutComponent;

    private isPreparePreviewEventLogged = false;

    selectedOption!: IAttributeConfDataOption;

    readonly client = inject(Client);
    protected dfModalService = inject(DfModalService);

    override openXnotifEmail(): void {
        this.app.events.broadcast('xnotif-open');
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(
            this.basketService.addToBasketSuccessSubject.subscribe(() => {
                if (this.client.isM || this.client.isS) {
                    this.unPick();
                }
            })
        );

        this.subscriptions.add(
            this.dfEventService.success(eventData => {
                if (eventData.id === PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME) {
                    this.isPreparePreviewEventLogged = true;
                }
            })
        );
    }

    override ngOnDestroy(): void {
        this._data = {};

        super.ngOnDestroy();
    }

    get attribute(): IAttributeConfData | undefined {
        return this.attributes && this.attributes[0];
    }

    override pick(attribute: string | IAttributeConfData, option: IAttributeConfDataOption) {
        this.selectedOption = option;

        if (this.isPreparePreviewEventLogged) {
            this.dfEventService.dispatch({
                id: PRODUCT_WISHLIST_ADD_EVENT_NAME,
                data: {
                    product: this.product as ProductDecorator<IProductDataV2>,
                    option
                },
                action: () => {
                    super.pick(attribute, option);
                    this.isPreparePreviewEventLogged = false;
                }
            });
        } else {
            super.pick(attribute, option);
        }
    }

    protected unPick() {
        if (this.data) {
            Object.keys(this.data).forEach(key => {
                if (key === 'size') {
                    delete this.data[key];
                }
            });
        }

        this.onDataChange(true);
    }

    protected override setAttributes(attributes?: IAttributeConfData[] | undefined) {
        this.attributes = attributes?.filter(i => i.code === 'size') || [];
    }

    protected override initSelection() {
        if (!this.product) {
            return;
        }

        super.initSelection();
    }
}
